<script setup>
import { computed, onMounted, ref } from 'vue'

const showActiveYears = ref([])

const props = defineProps({
  items: { required: true, type: Array },
  activeItems: { required: true, type: Array },
  parameter: { required: false, default: null },
  filterParameter: { required: false, default: 'id' }
})

const propActiveYears = computed({
  get() {
    return props.activeItems
  },
  set(value) {
    emit('update:activeItems', value)
  }
})

const emit = defineEmits(['update:activeItems', 'update'])

const addOrDelete = (item) => {
  const index = propActiveYears.value.findIndex(
    (activeYear) => activeYear[props.filterParameter] === item[props.filterParameter]
  )
  if (index === -1) {
    propActiveYears.value.push(item)
  } else {
    if (props.activeItems.length === 1) {
      return
    }
    propActiveYears.value.splice(index, 1)
  }
  propActiveYears.value.sort((a, b) => a[props.parameter] - b[props.parameter])
  emit('update')
}

onMounted(() => {
  showActiveYears.value = [...Array(props.items.length).keys()]
})
</script>
<template>
  <v-chip-group
    multiple
    mandatory
    color="primary"
    active-class="primary--text"
    column
    v-model="showActiveYears"
    style="display: inline-block; white-space: nowrap"
  >
    <v-chip
      color="primary"
      v-for="item in items"
      :key="item.id"
      @click="addOrDelete(item)"
      class="mb-0"
    >
      <span v-if="parameter">
        {{ item[parameter] }}
      </span>
      <span v-else>
        {{ item }}
      </span>
    </v-chip>
  </v-chip-group>
</template>
